import './BackLink.scss';

import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import Button, { ButtonStyle } from '@components/Button';

interface IProps {
  children: ReactNode | ReactNode[];
  to: string;
}

function BackLink({ children, to }: IProps) {
  const { t } = useTranslation();

  return (
    <div className="modBackLink">
      <Button type="link" style={ButtonStyle.Action} to={to}>
        <i className="modIcon modIcon--chevron-left" />
        {t('general.backTo')} {children}
      </Button>
    </div>
  );
}

export default BackLink;
